"use client";

import React from "react";
import styles from "./Logo.module.scss";

// Helpers
import classnames from "classnames";

// Components
import Link from "next/link";
import Image from "@/app/[lang]/components/shared/SmartImage";
import { usePathname } from "next/navigation";

const Logo = ({
  src,
  alt,
  children,
  className,
}: {
  src: string | null;
  alt: string | null;
  children?: React.ReactNode;
  className?: string;
}) => {
  const pathname = usePathname();
  const langFromPath = pathname?.split("/")[1];
  const href = langFromPath ? `/${langFromPath}` : "/ro";

  if (!src && !children) return null;

  return (
    <Link href={href} aria-label="Back to homepage">
      {src && (
        <Image
          width={167}
          height={38}
          src={src}
          alt={alt ?? "PPC Blue Romania"}
          priority
          className={classnames(styles.logo, className)}
        />
      )}
      {children && <div className="ml-2">{children}</div>}
    </Link>
  );
};

export default Logo;
